import React from 'react';
import { useSelector } from 'react-redux';
import { selectChatbotProps } from '@/store/selectors/chatbotSelectors';
import styles from './styles/chatbot-content.module.css';
import BlockManager from './content/BlockManager';
import InputManager from './content/InputManager';

const ChatbotContent = () => {
  const { isInactive, hasNoBlocks } = useSelector(selectChatbotProps);

  if (isInactive) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.status_message_wrapper}>
          <p className={styles.status_message}>
            This chatbot is currently inactive.
          </p>
        </div>
      </div>
    );
  }

  if (hasNoBlocks) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.status_message_wrapper}>
          <p className={styles.status_message}>
            This chatbot has no message blocks.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <BlockManager />
      <InputManager />
    </div>
  );
};

export default ChatbotContent;
